import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { MessageTemplateRecord } from '@workspace/types';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { contactAgentApi } from '../api/contactAgentApi';
import { contactAgentError } from '../api/contactAgentScope';
import { MessageTemplatePreview } from './MessageTemplatePreview';

export function MessageTemplatePicker({
  channelKind,
  value,
  onChange,
  onPersistWizard,
}: {
  channelKind: 'SMS' | 'EMAIL';
  value: string;
  onChange: (templateId: string) => void;
  onPersistWizard: () => void;
}) {
  const [items, setItems] = useState<MessageTemplateRecord[]>([]);
  const [error, setError] = useState('');
  const selected = items.find(item => item.id === value) ?? null;

  useEffect(() => {
    setError('');
    void contactAgentApi
      .listMessageTemplates({ channelKind, status: 'ACTIVE' })
      .then(setItems)
      .catch(err => setError(contactAgentError(err)));
  }, [channelKind]);

  return (
    <div className='md:col-span-2 space-y-4'>
      <div className='space-y-2'>
        <Label htmlFor='messageTemplateId'>Plantilla activa</Label>
        <select
          id='messageTemplateId'
          className='flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm'
          value={value}
          onChange={event => onChange(event.target.value)}
        >
          <option value=''>Elegi una plantilla</option>
          {items.map(item => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
        {error ? <p className='text-sm text-destructive'>{error}</p> : null}
        <p className='text-xs text-muted-foreground'>
          La campaña usa una plantilla de la biblioteca, no un texto suelto.{' '}
          <Link
            className='underline'
            to={`/admin/campaigns/templates?kind=${channelKind}&returnTo=wizard`}
            onClick={onPersistWizard}
          >
            Crear plantilla
          </Link>
        </p>
        {items.length === 0 && !error ? (
          <Button type='button' variant='outline' size='sm' asChild>
            <Link to={`/admin/campaigns/templates?kind=${channelKind}&returnTo=wizard`} onClick={onPersistWizard}>
              Crear la primera
            </Link>
          </Button>
        ) : null}
      </div>
      {selected ? (
        <MessageTemplatePreview
          channelKind={channelKind}
          subject={selected.subject ?? ''}
          bodyText={selected.bodyText}
        />
      ) : null}
    </div>
  );
}
